var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fontClass
    ? _c("i", {
        class: _vm.iconName,
        on: {
          click: function ($event) {
            return _vm.click(_vm.iconName, $event)
          },
        },
      })
    : _vm.svg
    ? _c(
        "svg",
        {
          class: _vm.svgClass,
          attrs: { "aria-hidden": "true" },
          on: {
            click: function ($event) {
              return _vm.click(_vm.iconName, $event)
            },
          },
        },
        [_c("use", { attrs: { "xlink:href": _vm.iconName } })]
      )
    : _vm.isExternal
    ? _c("div", {
        staticClass: "icon external-icon",
        class: _vm.className,
        style: _vm.styleExternalIcon,
        on: {
          click: function ($event) {
            return _vm.click(_vm.iconName, $event)
          },
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }